import {InvoiceOffice, Office} from "../common/Office";
import {Module} from "../common/Module";
import {isPrivileged} from "../../config/Privileges";
import {CUSTOMER_AREA_NAME} from "./CustomerModule";
import {CustomerId} from "./Customer";

export const CustomerOfficeModule: Module = {
    identifier: "customer_offices" ,
    isPrivileged: ( authUser, privilege ) =>
        isPrivileged(
            authUser,
            CUSTOMER_AREA_NAME,
            CustomerOfficeModule.identifier,
            privilege
        ),
};

export interface CustomerOffice extends InvoiceOffice, CustomerId {

}

export type CustomerOfficeProp = {
    customerOffice: CustomerOffice
}